
import styled from 'styled-components';
import { Svg } from '@/components/styled';
import { ICONS, List as IconsList } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderIcons } from '@/utilities/functions';

const SubTitleContainer = styled.h3`
	align-items: center;
	color: ${({ theme }) => theme.color.prune};
	display: flex;
	font-size: ${({ theme }) => theme.fontSize.XXLARGE};
	font-weight: bold;
	padding: 0; margin: 0;

	svg {
		width: 48px;
		min-width: 48px;
		max-width: 48px;
		padding-right: .5rem;
	}

	@media screen and (${devices.mobile}) {
		text-align: center;
		flex-direction: column;
	}
`;

const SubtitleWithIcon = ({
	subtitleIcon,
	subtitle,
	color,
	svgFill,
	svgCircle,
	svgPath,
	svgStroke,
}: {
	subtitleIcon?: ICONS;
	subtitle: string;
	color?: string;
	svgFill?: string;
	svgCircle?: string;
	svgPath?: string;
	svgStroke?: string;
}) => {

	return (
		<SubTitleContainer>
			{subtitleIcon && (
				<Svg
					color={color ? color : 'prune'}
					fill={svgFill ? svgFill : 'prune'}
					circle={svgCircle ? svgCircle : 'prune'}
					path={svgPath ? svgPath : ''}
					stroke={svgStroke ? svgStroke : ''}
					size={{
						height: '48px',
						width: '48px',
					}}
				>
					{renderIcons(subtitleIcon, IconsList)}
				</Svg>
			)}
			{subtitle}
		</SubTitleContainer>
	);
};

export default SubtitleWithIcon;
